// extracted by mini-css-extract-plugin
export default {"wrapper":"Slider_wrapper__IZYhs","container":"Slider_container__7AhRF"};